import { call, put, takeLatest } from 'redux-saga/effects'
import {
  getAllVitals
} from './vital.reducer'
import Api from '../services/ApiCaller'

function* getAllVitalsRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getAllVitals.success(res))

    } else {
      yield put(getAllVitals.failure(message))
    }
  } catch (e) {
    yield put(getAllVitals.failure(e.message))
  }
}

export default (api: any) => {
  const getAllVitalsApi = (data: any) => api.get(`/readings/${data.id}`, data)
  return [
    takeLatest(getAllVitals.TRIGGER, getAllVitalsRequest, getAllVitalsApi)
  ]

}
